const colors = {
    primary: '#6060FF',
    secondaryA: '#8040FF',
    secondaryB: '#4080FF',
    black: '#0F0F28',
    grey: '#56606D',
    silver: '#747e8b',
    lightgrey: '#BFD3E7',
    highlight: 'rgba(0,0,0,0.1)',
    highlightLight: 'rgba(0,0,0,0.05)',
    success: '#34A853',
};
export default colors;
